export class PartnerSelectOption {
  constructor(
    public displayName: string,
    public value: string,
    public integrationType?: string
  ) {}
}
